import { useId } from "react";

import { FormField } from "~/components/ui/form-field";
import { Input } from "~/components/ui/input";

import { useFieldContext } from "./field-context";
import { useFieldError } from "./field-errors";

export function TextField({
  label,
  type = "text",
  placeholder,
  required,
  helpText,
  isPrivate,
  maxLength,
  disabled,
  aiFill,
}: {
  label?: string;
  type?: "text" | "url" | "date" | "time" | "email" | "tel" | "password";
  placeholder?: string;
  required?: boolean;
  helpText?: string;
  isPrivate?: boolean;
  maxLength?: number;
  disabled?: boolean;
  aiFill?: boolean;
}) {
  const field = useFieldContext<string | null | undefined>();
  const error = useFieldError(field.name);
  const id = useId();
  return (
    <FormField
      inputId={id}
      label={label}
      required={required}
      helpText={helpText}
      error={error}
      isPrivate={isPrivate}
      onAiFillField={aiFill ? field.handleChange : undefined}
    >
      <Input
        id={id}
        type={type}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        value={field.state.value ?? ""}
        onValueChange={field.handleChange}
        onBlur={field.handleBlur}
      />
    </FormField>
  );
}
